<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div style="width: calc(100vw - 268px); margin-bottom: 32px" class="" [hidden]="loadingCounter > 0">
  <div class="grid nested-grid">
    <div class="col-9" style="padding-bottom: 0!important;">
      <p-accordion class="w-full background-249" [activeIndex]="0" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
        <p-accordionTab iconPos="end">
          <ng-template pTemplate="header">
            <div class="grid">
              <div class="col-2">
                <med-icon-aimbulance
                  size="48"
                  mode="square"
                ></med-icon-aimbulance>
              </div>

              <div class="col-10">
                      <span class="white-space-nowrap postavka">
                          Дочірній розподіл від розподілу №{{parentDistribution.orderName}} &nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                <br>
                <div class="flex flex-between gap-3">
                  <div class="h10-text" style="display: inline-flex">Статус:&nbsp; <img [src]="getPathToStatusImg(distribution.status)" width="4" height="16" style="vertical-align: middle;"/>&nbsp; {{getStatus()}}</div>
                  <div class="h10-text" style="display: inline-flex" *ngIf="distributionApproved">Рішення:&nbsp; <img [src]="getPathToStatusImg('active')" width="4" height="16" style="vertical-align: middle;"/>&nbsp;Розподілено</div>
                  <div class="h10-text black-80" *ngIf="distribution.limit">
                    <med-bubble [styleClass]="'med-bubble-red-30'">Ліміт розподілу: {{distribution.limit}}</med-bubble>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <div class="grid" style="margin: .5em .1em 0 .1em; border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 8vh">


            <div class="col-3">
                      <span class="mobile-h10-text">
                          Дата розподілу
                      </span>
              <br>
              <span class="h10-text">
                          {{distribution.orderDate | date: 'dd.MM.yyyy'}}
                      </span>
            </div>
            <div class="col-3">
              <span class="mobile-h10-text">
                          Розподіл виконано
                      </span>
              <br>
              <span class="h10-text">
                          {{distribution.distributionType}}
                      </span>
            </div>
            <div class="col-3">
              <span class="mobile-h10-text">
                          Напрям
                      </span>
              <br>
              <span class="h10-text">
                          Антидепресанти
                      </span>
            </div>
            <div class="col-3">
              <span class="mobile-h10-text">
                          Регіон
                      </span>
              <br>
              <span class="h10-text">
                          Івано-Франківська обл.
                      </span>
            </div>


          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div class="col-3" style="padding-bottom: 0!important;">
      <p-accordion class="w-full background-249" [activeIndex]="0" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
        <p-accordionTab iconPos="end">
          <ng-template pTemplate="header">
            <div class="grid">
              <div class="col-6">
                <med-icon-key-large
                  size="48"
                  mode="circle"
                ></med-icon-key-large>
              </div>

              <div class="col-6 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
              </div>
            </div>
          </ng-template>

          <div class="grid" style="padding: 8px; margin: .5em .1em 0 .1em; border: 1px solid rgb(220, 220, 220); border-radius: 5px; height: 8vh">
            <div class="col-6">
              <span class="mobile-h10-text">
                          ПІБ
                      </span>
              <br>
              <span class="h10-text">
                          {{ signerFullName() }}
                      </span>
            </div>
            <div class="col-6">
              <span class="mobile-h10-text">
                          Дата
                      </span>
              <br>
              <span class="h10-text">
                          {{ signerDate() | date: 'dd.MM.yyyy' }}
                      </span>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>


<div class="table-wrapper" style="height: 100%; margin-bottom: 108px" *ngIf="rows.length">
  <p-table
    #dt
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="rows"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [columns]="tabHeader"
    [reorderableColumns]="true"
    (onColReorder)="saveColumnOrder()">
    <ng-template pTemplate="header">
      <tr>
        <th class="table-header-text" *ngFor="let column of tabHeader" style="min-width: 10em"  [ngStyle]="{'background-color': column.key === '9' ? '#CCD7ED' : 'rgb(249, 249, 249)'}" pReorderableColumn pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'min-width': '5em'}" *ngIf="column.key !== '2' && column.key !== '9' && column.key !== '7' && column.key !== '8'">
              {{ column.label }}&nbsp;

            <div *ngIf="column.key === '5'">
              <med-btn skin="white" (click)="updateRemnants()" [pTooltip]="tooltipContentRemnants" [disabled]="updateRemnantsInProgress" *ngIf="!READONLY">
                <med-icon-refresh size="18" [ngClass]="{'animate--rotate': updateRemnantsInProgress}"></med-icon-refresh>
              </med-btn>
            </div>
            <ng-template #tooltipContentRemnants>
              <div class="flex items-center h10-text">
                Оновити залишки
              </div>
            </ng-template>

            <div *ngIf="column.key === '4'">
              <med-btn skin="white" (click)="updateDistribution100Financed()" [pTooltip]="tooltipContentFinanced" [disabled]="updateDistribution100FinancedInProgress" *ngIf="!READONLY">
                <med-icon-refresh size="18" [ngClass]="{'animate--rotate': updateDistribution100FinancedInProgress}"></med-icon-refresh>
              </med-btn>
            </div>
            <ng-template #tooltipContentFinanced>
              <div class="flex items-center h10-text">
                Оновити 100% потреба профінансовано
              </div>
            </ng-template>

          </div>
          <div style="display: inline-block" class="flex align-items-center no-wrap flex-between" *ngIf="column.key === '2'">
            <div style="margin-right: 3em">
              Кількість
            </div>
            <div style="cursor: pointer">
              <med-icon-chevron-right size="18"></med-icon-chevron-right>
            </div>
          </div>
          <div style="display: inline-block" class="flex align-items-center flex-between" *ngIf="column.key === '7'">
            <div style="margin-right: 3em">
              Автоматичний розподіл, враховуючи залишки
            </div>
            <ng-template #tooltipContent1>
              <div class="flex items-center h10-text">
                Скопіювати значення у фінальний розподіл
              </div>
            </ng-template>
            <div style="cursor: pointer"  (click)="copyFromAutoToFinal()" (mouseenter)="copyAutoToFinal.show($event)" (mouseleave)="copyAutoToFinal.hide()" *ngIf="distribution.status === 'DRAFT' && !READONLY">
              <med-icon-copy size="18"></med-icon-copy>
              <p-overlayPanel #copyAutoToFinal>
                <div class="flex items-center h10-text">
                  Скопіювати
                </div>
              </p-overlayPanel>
            </div>
          </div>
          <div style="display: inline-block" class="flex align-items-center flex-between" *ngIf="column.key === '8'">
            <div style="margin-right: 3em">
              Пропорційний розподіл
            </div>
            <ng-template #tooltipContent2>
              <div class="flex items-center h10-text">
                Скопіювати значення у фінальний розподіл
              </div>
            </ng-template>
            <div style="cursor: pointer"  *ngIf="distribution.status === 'DRAFT'">
              <med-icon-copy size="18" (click)="copyFromProportionalToFinal()" (mouseenter)="copyProportionToFinal.show($event)" (mouseleave)="copyProportionToFinal.hide()"></med-icon-copy>
              <p-overlayPanel #copyProportionToFinal>
                <div class="flex items-center h10-text">
                  Скопіювати
                </div>
              </p-overlayPanel>
            </div>
          </div>
          <div style="display: inline-block" class="flex align-items-center flex-between" *ngIf="column.key === '9'">
            <div style="margin-right: 3em">
              Фінальний розподіл
            </div>
            <div style="cursor: pointer">
              <med-icon-refresh size="18" *ngIf="!READONLY" (mouseenter)="refreshFinalResult.show($event)" (mouseleave)="refreshFinalResult.hide()"></med-icon-refresh>
              <p-overlayPanel #refreshFinalResult>
                <div class="flex items-center h10-text">
                  Скинути
                </div>
              </p-overlayPanel>
            </div>
          </div>
      </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowRes let-rowIndex="rowIndex" let-columns="columns">
<!--      <ng-container *ngFor="let recipient of rowRes.recipients">-->
      <tr class="table-content-text" *ngFor="let recipient of filterNotDeleted(rowRes.recipients); let i = index">
        <ng-container *ngFor="let col of columns">

        <td class="h10-text black-80"  *ngIf="i === 0 && col.key === '1'" [attr.rowspan]="rowRes.recipients.length">
          {{rowRes.mnnId}}
        </td>
        <td class="h10-text black-80" *ngIf="i === 0 && col.key === '2'" [attr.rowspan]="rowRes.recipients.length">
          {{rowRes.quantity}}
        </td>
          <td class="h10-text black-80" *ngIf="i === 0 && col.key === '11'" [attr.rowspan]="rowRes.recipients.length">
            {{getRemnant(rowRes)}}
          </td>
          <td class="h10-text black-80" style="border-right: 1px solid #ebedff" *ngIf="i === 0 && col.key === '12'" [attr.rowspan]="rowRes.recipients.length">
            {{distribution.limit}}
          </td>

            <td class="h10-text black-80" *ngIf="col.key === '3'">
              <div *ngIf="recipient.id !== 'plus'">
                {{recipient.recipientName}}
              </div>
              <div *ngIf="recipient.id === 'plus' && distribution.status === 'DRAFT'">
                <div style="width: fit-content">
                  <med-btn size="small" (click)="showAddRecipientsModal(rowRes)" skin="gray">
                    <med-icon-plus size="12" (mouseenter)="plus1.show($event)" (mouseleave)="plus1.hide()"></med-icon-plus>
                    <p-overlayPanel #plus1>
                      <div class="flex items-center h10-text">
                        Додати
                      </div>
                    </p-overlayPanel>
                  </med-btn>
                </div>
              </div>
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '4'">
              {{recipient.requisition}}
            </td>

            <td class="h10-text black-80" *ngIf="col.key === '5'">
              {{recipient.remnants}}
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '6'">
              {{recipient.dividedPerYear}}
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '7'">
              {{recipient.distributedAuto}}
            </td>
            <td class="h10-text black-60" *ngIf="col.key === '8'">
              {{recipient.distributedProportional}}
            </td>
            <td class="h10-text black-90" [ngStyle]="{'background-color': recipient.id !== 'plus' ? '#F5F9FF' : ''}" *ngIf="col.key === '9'">
              <div *ngIf="recipient.id !== 'plus'">
                <med-input  [size]="'small'"  type="number" *ngIf="distribution.status === 'DRAFT' || distribution.status === 'AWAITING_DOZ_DISTRIBUTION'"
                            [state]="inputWithDigitalFractionOrInvalid(recipient.distributedFinally, rowRes.quantity, rowRes.mnnId) ?'error': ''"
                            [(ngModel)]="recipient.distributedFinally"
                            (focusout)="checkIfSumInMNNIsCorrect()"></med-input>
                <span *ngIf="distribution.status === 'COMPLETED'">
                  {{recipient.distributedFinally}}
                </span>
              </div>
            </td>
            <td class="h10-text" *ngIf="col.key === '10'">
              <div *ngIf="recipient.id !== 'plus'">
                <med-icon-delete size="16" (mouseenter)="deleteBeneficiar.show($event)" (mouseleave)="deleteBeneficiar.hide()"></med-icon-delete>
                <p-overlayPanel #deleteBeneficiar>
                  <div class="flex items-center h10-text">
                    Видалити
                  </div>
                </p-overlayPanel>
              </div>
            </td>
          </ng-container>
<!--      </ng-container>-->
      </tr>
    </ng-template>
  </p-table>
</div>



<div
  [style.width]="'calc(100vw - 0px)'"
  [style.height]="'60px'"
  class="med-layout__footer"
>
  <div class="med-layout__footer-content">
    <div class="flex flex-center flex-between">
      <div class="flex flex-center">

        <med-btn class="mr-1" (click)="goToDistributions()">
          <med-icon-reply size="18"></med-icon-reply>
          &nbsp;
          <span>До реєстру розподілу</span>
        </med-btn>
        <med-btn class="mr-1" (click)="goToSeries()" *ngIf="!READONLY">
          <med-icon-plus size="16"></med-icon-plus>
          &nbsp;
          <span>Серії/Каталожні номери</span>
        </med-btn>

        <med-btn class="mr-1" (click)="setupLimitModal = true" *ngIf="!READONLY">
          <span>Ліміт розподілу</span>
        </med-btn>

        <med-btn class="mr-1" (click)="openAttachmentsModal()">
          <span>Вкладення</span>
          &nbsp;
          {{ attachments.content.length }}
        </med-btn>

        <med-btn class="mr-1" (click)="reviewModal = true">
          <span>Переглад</span>
          &nbsp;
          <med-icon-visibility size="18"></med-icon-visibility>
        </med-btn>

        <med-btn class="mr-1" (click)="openDownloadExcelModal()">
          <med-icon-download size="18"></med-icon-download>
        </med-btn>

      </div>
      <div class="flex flex-center">
        <med-btn class="ml-1" *ngIf="distribution.status === 'DRAFT'" (click)="archive()">
          <med-icon-archive size="16"></med-icon-archive>
          &nbsp;
          <span>Архівувати</span>
        </med-btn>

        <med-btn skin="red" class="ml-1" (click)="sendToReworking()" *ngIf="distribution.status === 'AWAITING_DOZ_DISTRIBUTION'">
          <med-icon-arrow-circle-left size="18"></med-icon-arrow-circle-left>
          &nbsp;
          <span>Відправити на доопрацювання</span>
        </med-btn>

        <med-btn skin="yellow" class="ml-1" (click)="subDistributionAgreementModal = true" *ngIf="distribution.status === 'DRAFT'">
          <span>Перейти до погодження</span>
          &nbsp;
          <med-icon-arrow-right size="18"></med-icon-arrow-right>
        </med-btn>

        <med-btn skin="yellow" class="ml-1" (click)="invokeSignModal()" *ngIf="distribution.status === 'AWAITING_DOZ_DISTRIBUTION'">
          <span>Підтвердити розподіл</span>
          &nbsp;
          <med-icon-check size="18"></med-icon-check>
        </med-btn>
      </div>
    </div>
  </div>
</div>

<med-modal
  [(visible)]="reviewModal">
  <app-view-distribution-modal [distributionId]="subDistributionId" [isDoz]="true" [isSub]="true"></app-view-distribution-modal>
</med-modal>


<med-modal
  [(visible)]="downloadExcelModal"
>
  <div class="em-50">
    <div class="grid">
      <div class="col-2">
        <med-icon-docs
          size="48"
          mode="square"
        ></med-icon-docs>
      </div>

      <div class="col-10 p-grid justify-content-center align-content-center">
        <span class="white-space-nowrap text-h6-heading">
          Завантажити розподіл
        </span>
      </div>
    </div>

    <br/>
    <br/>

    <div class="grid">
      <div class="col-12">
        <span class="white-space-nowrap text-h7-left">
          Оберіть тип файлу, який ви бажаєте завантажити
        </span>
      </div>
    </div>

    <br/>

    <div class="grid">
      <div class="col-12">
        <med-radio-group position="" class="report_options_radiogroup" [options]="downloadReportOptions" [value]="downloadReportValue" (onInput)="downloadReportOptionChanged($event)"></med-radio-group>
      </div>
    </div>

    <br/>

    <div class="grid">
      <div class="col-5">
        <med-btn class="width-100" size="large" skin="gray" (click)="cancelDownloadReport()" >Скасувати</med-btn>
      </div>
      <div class="col-5">
        <med-btn class="width-100" size="large" skin="" (click)="downloadExcel()">Підтвердити</med-btn>
      </div>
    </div>


  </div>
</med-modal>

<med-modal [(visible)]="refuseModal" [closeableOutside]="false">
  <div style="padding: 5px 10px">

    <app-loader *ngIf="refuseRequestCounter > 0" [ngStyle]="{'width': '480px', 'display': 'flex'}"></app-loader>


    <div style="width: 480px"  *ngIf="refuseRequestCounter === 0 && !refused">
      <div class="flex flex-center justify-content-center">
        <div><img src="assets/images/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Відправити на доопрацювання
      </div>

      <div style="margin-top: 24px">
        <span class="h10-text black-60">
          Коментар
        </span>
        <span class="h10-text black-30">
          0/1000
        </span>
      </div>

      <div>
        <med-textarea height="88px" [state]="commentStatus" [(ngModel)]="comment">

        </med-textarea>
      </div>

<!--      <div style="margin-top: 24px">-->
<!--        <med-card>-->
<!--          <div class="flex flex-between flex-center">-->
<!--            <med-radio-group position="horizontal" [options]="options" [value]="value"></med-radio-group>-->
<!--            &lt;!&ndash;            <med-icon-close></med-icon-close>&ndash;&gt;-->
<!--          </div>-->
<!--          <div style="margin-top: 24px" class="flex flex-between flex-center">-->
<!--            <div style="width: 50%">-->
<!--              <med-input label="Номер документу"></med-input>-->
<!--            </div>-->
<!--            <div style="width: 50%; margin-left: 10px">-->
<!--              <med-datepicker label="Дата"></med-datepicker>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div style="margin-top: 24px">-->
<!--            <div style="width: 100%">-->
<!--              <med-upload-file></med-upload-file>-->
<!--            </div>-->
<!--          </div>-->
<!--        </med-card>-->
<!--      </div>-->

<!--      <div style="margin-top: 16px" class="flex flex-center justify-content-center">-->
<!--        <med-btn [disabled]="true">-->
<!--          <med-icon-plus [ngStyle]="{'width': '16px'}" size="small"></med-icon-plus>-->
<!--          Додати ще вкладення-->
<!--        </med-btn>-->
<!--      </div>-->

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="refuseDistribution()">
          Відправити
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 12px">
        <med-btn skin="gray" (click)="refuseModal =false">
          Скасувати
        </med-btn>
      </div>

    </div>

    <div style="width: 480px" *ngIf="refuseRequestCounter === 0 && refused">

      <div class="flex flex-center justify-content-center">
        <div><img src="assets/images/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Відправити на доопрацювання
      </div>

      <div style="padding-top: 24px">
        <med-card>
          <div class="grid" style="padding: 24px">
            <div class="col-2">
              <med-icon-key-large
                size="48"
                mode="circle"
              ></med-icon-key-large>
            </div>

            <div class="col-10 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
            </div>
          </div>
          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              П.І.Б
            </div>
            <div class="col-6 mobile-h10-text black-60">
              Час підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              Крушельницька М.
            </div>
            <div class="col-6 h10-text black-80">
              10.12.2023 17:25
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Оргацізація
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              Департамент охорони здоров`я
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Серійний номер підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              А0000123123120000000000123100001
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              ЄДРПОУ організації
            </div>
            <div class="col-6 mobile-h10-text black-60">
              ДРФО
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              12345678
            </div>
            <div class="col-6 h10-text black-80">
              12345678
            </div>
          </div>
        </med-card>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="refuseDone()">
          Готово
        </med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal [(visible)]="signModal" [closeableOutside]="false">
  <!--  <div style="padding: 80px 148px">-->
  <div style="padding: 5px 10px">

    <app-loader *ngIf="signRequestCounter > 0" [ngStyle]="{'width': '480px', 'display': 'flex'}"></app-loader>

    <div style="width: 480px" *ngIf="signRequestCounter === 0 && !signed">
      <div class="flex flex-center justify-content-center">
        <div><img src="assets/icons/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Підтвердити розподіл
      </div>

      <div style="margin-top: 24px">
        <med-card>
          <div class="flex flex-between flex-center">
            <med-radio-group position="horizontal" [options]="options" [value]="value"></med-radio-group>
            <!--            <med-icon-close></med-icon-close>-->
          </div>
          <div style="margin-top: 24px" class="flex flex-between flex-center">
            <div style="width: 50%">
              <med-input label="Номер документу"></med-input>
            </div>
            <div style="width: 50%; margin-left: 10px">
              <med-datepicker label="Дата"></med-datepicker>
            </div>
          </div>
          <div style="margin-top: 24px">
            <div style="width: 100%">
              <med-upload-file></med-upload-file>
            </div>
          </div>
        </med-card>
      </div>

      <div style="margin-top: 16px" class="flex flex-center justify-content-center">
        <med-btn [disabled]="true">
          <med-icon-plus [ngStyle]="{'width': '16px'}" size="small"></med-icon-plus>
          Додати ще вкладення
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="invokeSignModal()">
          Підписати
        </med-btn>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 12px">
        <med-btn skin="gray">
          Скасувати
        </med-btn>
      </div>

    </div>

    <div style="width: 480px" *ngIf="signRequestCounter === 0 && signed">

      <div class="flex flex-center justify-content-center">
        <div><img src="assets/icons/Enter.png"></div>
      </div>

      <div class="flex flex-center justify-content-center h6-heading" style="margin-top: 12px">
        Підтвердити розподіл
      </div>

      <div style="margin-top: 24px">
        <med-card *ngIf="decryptedObject && decryptedObject.signerInfo">
          <div class="grid" style="padding: 24px">
            <div class="col-2">
              <med-icon-key-large
                size="48"
                mode="circle"
              ></med-icon-key-large>
            </div>

            <div class="col-10 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              KEП
                          </span>
            </div>
          </div>
          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              П.І.Б
            </div>
            <div class="col-6 mobile-h10-text black-60">
              Час підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjFullName}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signedAt | date: 'dd.MM.yyyy hh:mm'}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Оргацізація
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.issuerCN}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-12 mobile-h10-text black-60">
              Серійний номер підпису
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-12 h10-text black-80">
              {{decryptedObject.signerInfo.serial}}
            </div>
          </div>


          <div class="grid" style="margin-top: 24px">
            <div class="col-6 mobile-h10-text black-60">
              ЄДРПОУ організації
            </div>
            <div class="col-6 mobile-h10-text black-60">
              ДРФО
            </div>
          </div>

          <div class="grid" style="margin-top: 8px">
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjEDRPOUCode}}
            </div>
            <div class="col-6 h10-text black-80">
              {{decryptedObject.signerInfo.subjDRFOCode}}
            </div>
          </div>
        </med-card>
      </div>

      <div class="flex flex-center justify-content-center" style="margin-top: 24px">
        <med-btn (click)="signDone()">
          Готово
        </med-btn>
      </div>
    </div>
  </div>
</med-modal>

<!--<med-modal-->
<!--  [(visible)]="subDistributionAgreementModal"-->
<!--  class="no-padding"-->
<!--&gt;-->
<!--  <div style="width: 383px; height: 316px; padding: 32px">-->
<!--    <div class="flex justify-content-center">-->
<!--      <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>-->
<!--    </div>-->
<!--    <div class="text-h6-heading" style="margin-top: 12px">-->
<!--      Ви впевнені, що бажаєте створити дочірній розподіл?-->
<!--    </div>-->
<!--    <div style="margin-top: 32px">-->
<!--      <div>-->
<!--        <med-btn (click)="createSubDistribution()" class="width-100">Підтвердити</med-btn>-->
<!--      </div>-->
<!--      <div class="mt-1">-->
<!--        <med-btn skin="gray" (click)="subDistributionAgreementModal = false" class="width-100">Скасувати</med-btn>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</med-modal>-->

<med-modal
  [(visible)]="medSignModal"
  class="no-padding"
>
  <div style="width: 1000px; height: 600px; padding: 32px">
    <med-sign *ngIf="medSignModal"
      [data]="JSON.stringify(dataToSign)"
      (sign)="onSign($event)"
    ></med-sign>
  </div>
</med-modal>

<med-modal
  [(visible)]="subDistributionAgreementModal"
  class="no-padding"
>
  <div style="width: 383px; height: 316px; padding: 32px">
    <div class="flex justify-content-center">
      <med-icon-check-circle-fill [ngStyle]="{'width': '32px'}"></med-icon-check-circle-fill>
    </div>
    <div class="text-h6-heading" style="margin-top: 12px">
      Ви впевнені, що бажаєте відправити дочірній розподіл на погодження в ДОЗ?
    </div>
    <div style="margin-top: 32px">
      <div>
        <med-btn (click)="agreeSubDistribution()" class="width-100">Підтвердити</med-btn>
      </div>
      <div class="mt-1">
        <med-btn skin="gray" (click)="subDistributionAgreementModal = false" class="width-100">Скасувати</med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal
  [(visible)]="attachmentsModal"
>
  <div>
    <div class="flex flex-center mb-4">
      <med-icon-docs
        size="36"
        mode="square"
      ></med-icon-docs>

      <h6 class="text extra-large ml-2 mb-0 mt-0">
        Вкладення
      </h6>
    </div>

    <app-loader *ngIf="attachments.isLoading"></app-loader>
    <div class="table-wrapper" style="height: unset" *ngIf="!attachments.isLoading">
      <p-table
        #dt
        styleClass="p-datatable-sm"
        [scrollable]="true"
        scrollHeight="flex"
        [value]="attachments.content"
        [customSort]="true"
        [lazy]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [columns]="attachmentsTabHeader"
        [reorderableColumns]="true"
        (onColReorder)="saveColumnOrderCustom('attachemntsDozColumnOrder', attachmentsTabHeader)">

        <ng-template pTemplate="header">
          <tr>
            <ng-container *ngFor="let column of attachmentsTabHeader">
              <th class="mobile-h10-text table-header-bg-grey" pReorderableColumn pResizableColumn>
                <div style="display: inline-block" class="flex align-items-center">
                  {{ column.label }}&nbsp;
                </div>
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row  let-columns="columns">
          <tr class="table-content-text">
            <ng-container *ngFor="let col of columns">
              <td class="black-80 h9-text" *ngIf="col.key === '1'">
                {{ row.type }}
              </td>
              <td class="black-60 h10-text" *ngIf="col.key === '2'">
                {{ row.fileName }}
              </td>
              <td class="black-80 h9-text" *ngIf="col.key === '3'">
                {{ row.fileNumber }}
              </td>
              <td class="black-80 h9-text" *ngIf="col.key === '4'">
                {{ row.selectedDate | date: 'dd.MM.yyyy' }}
              </td>

              <td class="black-80 h9-text" *ngIf="col.key === '5'">
                {{row.owner}}
              </td>
              <td *ngIf="col.key === '6'">
                <med-btn size="small" skin="white">
                  <med-icon-download size="16" (click)="downloadFile(row)"></med-icon-download>
                </med-btn>
              </td>
            </ng-container>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>
</med-modal>

<med-modal
  [(visible)]="setupLimitModal"
  class="no-padding"
>
  <div style="width: 608px; padding: 32px">
    <div class="flex flex-center mb-4">
      <img style="padding: unset; margin-left: -1em" src="assets/icons/table/ic64-comments.png"
           width="64" height="64">

      <h6 class="text extra-large ml-2 mb-0 mt-0">
        Задати ліміт розподілу
      </h6>
    </div>
    <div class="h9-text" style="margin-top: 12px">
      Вкажіть загальну кількість одиниць, які можна розподілити у цьому розподілі
    </div>
    <div style="margin-top: 24px">
        <span class="h10-text black-60">
          Ліміт розподілу
        </span>
    </div>
    <div>
      <med-input type="number" [state]="hasMultiplicity() ?'error': ''" [(ngModel)]="distribution.limit"></med-input>
    </div>
    <div style="margin-top: 32px">
      <div>
        <med-btn (click)="setupLimit()" class="width-100">Підтвердити</med-btn>
      </div>
      <div class="mt-1">
        <med-btn skin="gray" (click)="setupLimitModal = false" class="width-100">Скасувати</med-btn>
      </div>
    </div>
  </div>
</med-modal>

<med-modal [(visible)]="addRecipientsModal" [closeableOutside]="false" [showCloseBtn]="false">
  <div [style]="{ width: '45vw', height: '65vh' }" class="flex flex-column">
    <div class="inline-flex align-items-start justify-content-start gap-2">
      <p-avatar
        [style]="{width: '1.5em', height: '1.5em'}"
        styleClass="mr-2"
        image="assets/icons/big_plus.png"
        shape="circle" />

      <span class="H6-Heading white-space-nowrap">
                    Додати заклад-отримувач
                </span>
      <div style="margin-left: auto; color: #666666; cursor: pointer" (click)="addRecipientsModal = false">
        <med-icon-close></med-icon-close>
      </div>
    </div>
    <div style="display: flex; flex-direction: column; height: 100%" class="mt-4">
      <div class="mobile-h10-text" style="padding-bottom: 1em">
        Напрям
      </div>
      <div class="h10-text black-80" style="padding-bottom: 3em">
<!--        {{directionForModal}}-->
      </div>
      <div class="mobile-h10-text" style="padding-bottom: 1em">
        Отримувачі
      </div>
      <div>
        <p-multiSelect
          [overlayVisible]="false"
          [style]="{ width: '100%', height: '8rem' }"
          [options]="recipientsForModalEntity"
          [(ngModel)]="selectedRecipients"
          [maxSelectedLabels]="7"
          placeholder="Оберіть отримувача"
          optionLabel="recipientName"
          display="chip"
          (onFocus)="disabledFlag=false"/>
      </div>
    </div>
    <div style="margin-top: auto; display: flex; flex-direction: row">
      <div style="width: 48%;">
        <med-btn skin="gray" (click)="addRecipientsModal = false">Скасувати</med-btn>
      </div>
      <div style="width: 48%; margin-left: auto">
        <med-btn [disabled]="disabledFlag" (click)="addRecipient()">Додати</med-btn>
      </div>
    </div>

  </div>
</med-modal>
